import React, { useEffect, useState } from "react";

interface BackgroundWrapperProps {
  /** Если нет (каталог и др.) — не грузим картинку, иначе в браузере получался запрос на `/null`. */
  image: string | null | undefined;
  fallbackColor?: string;
  /** На узком экране не показывать фоновую картинку, остаётся цвет фона. */
  plainOnMobile?: boolean;
  children: React.ReactNode;
}

const MOBILE_QUERY = "(max-width: 768px)";

const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({
  image,
  fallbackColor = "#dddee2",
  plainOnMobile = false,
  children,
}) => {
  const [isNarrow, setIsNarrow] = useState(
    () => window.matchMedia(MOBILE_QUERY).matches,
  );
  const [bgLoaded, setBgLoaded] = useState(false);
  const activeImage = isNarrow && plainOnMobile ? null : image;

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    const apply = () => setIsNarrow(media.matches);
    apply();
    media.addEventListener("change", apply);
    return () => media.removeEventListener("change", apply);
  }, []);

  useEffect(() => {
    if (!activeImage) {
      setBgLoaded(true);
      return;
    }
    setBgLoaded(false);
    const img = new Image();
    img.src = activeImage;
    img.onload = () => setBgLoaded(true);
    img.onerror = () => setBgLoaded(true);
  }, [activeImage]);

  return (
    <div
      className="page-bg"
      style={{
        minHeight: '100%',
        backgroundColor: fallbackColor,
        backgroundImage: bgLoaded && activeImage ? `url(${activeImage})` : "none",
        opacity: 1,
        transition: "opacity 1s ease-in-out",
      }}
    >
      {children}
    </div>
  );
};

export default BackgroundWrapper;
